import React, { useCallback } from 'react';
import { style } from 'typestyle';
import { CrossAxisAlignment } from '../flex/flex.component';
import Input from '../input/input.component';
import Row from '../row/row.component';
import divider from './time-input.styles';

interface Props {
  readonly className?: string;
  readonly hour?: number;
  readonly minute?: number;
  readonly onChange?: (hour: number, minute: number) => void;
}

const TimeInput = ({ className, hour = 0, minute = 0, onChange }: Props): React.JSX.Element => {
  const onHourChange = useCallback(
    (value: string) => {
      const int = parseInt(value, 10);

      if (int >= 0 && int <= 23) {
        onChange?.(int, minute);
      }
    },
    [onChange, minute],
  );

  const onMinuteChange = useCallback(
    (value: string) => {
      const int = parseInt(value, 10);

      if (int >= 0 && int <= 59) {
        onChange?.(hour, int);
      }
    },
    [onChange, hour],
  );

  return (
    <Row className={className} crossAxisAlignment={CrossAxisAlignment.Center}>
      <Input type="number" min={0} max={23} value={`0${hour}`.slice(-2)} onChange={onHourChange} />
      <div className={style(divider)}>:</div>
      <Input type="number" min={0} max={59} value={`0${minute}`.slice(-2)} onChange={onMinuteChange} />
    </Row>
  );
};

export default TimeInput;
